<div class="handshakes-detail">
  <div class="handshakes-detail__header">
    {{this.data.name}}
  </div>
  <div class="handshakes-detail__content" ubi-dialog-content>
    <div class="handshakes-detail__id">
      {{this.data.identificationNumber || '-'}}
    </div>
    <div class="handshakes-detail__item">
      <label class="handshakes-detail__title">Position:</label>
      <span class="handshakes-detail__text">{{this.data.position || '-'}}</span>
    </div>
    <div class="handshakes-detail__item">
      <label class="handshakes-detail__title">Address:</label>
      <span class="handshakes-detail__text">{{this.data.address || '-'}}</span>
    </div>
    <div class="handshakes-detail__item">
      <label class="handshakes-detail__title">Nationality:</label>
      <span class="handshakes-detail__text">{{this.data.nationality || '-'}}</span>
    </div>
    <div class="handshakes-detail__item">
      <label class="handshakes-detail__title">Appointment Date:</label>
      <span
        class="handshakes-detail__text">{{this.data.appointmentDate? (this.data.appointmentDate | date:'dd/MM/yyyy') : '-'}}</span>
    </div>
    <div class="handshakes-detail__hint">
      DOES THIS CRP ALREADY APPEAR IN THE ADDED CRP PROFILES LIST?
    </div>
    <div class="handshakes-detail__action" ubi-dialog-action>
      <div class="handshakes-detail__button">
        <button mat-stroked-button ubi-round-button class="btn btn_action"
          (click)="yes()">Yes</button>
        <button mat-stroked-button ubi-round-button class="btn btn_action" (click)="no()">No</button>
      </div>
      <button mat-stroked-button ubi-round-button class="btn" (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</div>
